import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class ReportsService extends BaseService {
  static get entity () {
    return 'v1/reports'
  }

  static async get (reportName, params = {}) {
    let paramString = ''
    if (Object.keys(params).length > 0) {
        paramString = `?${this.querystring(params)}`
    }

    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/${reportName}${paramString}`)
      console.log(response)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static getStringParam(params = {}){
    let paramString = ''
    if (Object.keys(params).length > 0) {
        paramString = `&${this.querystring(params)}`
    }
  
    return paramString
  }
  
  static async getObjectFee(periodIdList, params = {}, { signal }) {   
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/object-fee?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }

  static async getRaykomes(periodIdList, params = {}, { signal }) {
    console.log('getRaykomes param', params)
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/raykomes?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }

  static async getInactivePlayers(periodIdList, params = {}, { signal }) {
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/inactive-players?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }

  static async getActivePlayers(periodIdList, params = {}, { signal }) {
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/active-players?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }

  static async getRatioTopPlayers(periodIdList, params = {}, { signal }) {
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/ratio-top-players?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }

  static async getFeeByGameType(periodIdList, params = {}, { signal }) {
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/fee-by-game-type?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }
  
  static async getHandsByGameType(periodIdList, params = {}, { signal }) {
    try {
      const response = await this.request({ auth: true, signal }).get(`${this.entity}/hands-by-game-type?period_id=[${periodIdList}]${this.getStringParam(params)}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      if (error.name !== 'CanceledError') { 
        console.error('Ошибка при загрузке данных:', error);
        throw new ErrorWrapper(error, error.message);
      } 
    }
  }
}

